import { RouterState } from "react-router-redux";
import {uiItemNames,buttonActionTypes, revMode} from './enums'
import { ActionType } from 'typesafe-actions';
import {ThunkAction} from 'redux-thunk'
import { setAppSettings, setStateItem, setUiProperty, setUser } from "../actions/actionsBase";
import {User} from 'oidc-client'

export type SetPropertyAction = ActionType<typeof setUiProperty>;
export type SetItemAction = ActionType<typeof setStateItem>;
export type SetUserAction = ActionType<typeof setUser>;
export type SetAppSettingsAction = ActionType<typeof setAppSettings>;

export type AppActions = SetPropertyAction | SetItemAction | SetUserAction;
export type ThunkResult<R> = ThunkAction<R, IState, undefined, AppActions>;

export interface AppSettings {
    // dssUrl: string;
    apimSubKey: string;
}

export interface BasicAppProps
{
    isVisible:boolean;
    isLoading:boolean;
    hasErrored:boolean;
}

export interface IState 
{    
    oidc: User|null;
    uiState: UiState;
    uiItems: UiItemState;
    appSettings:AppSettings; 
    routing: RouterState;
}

export interface UiState {
    MAIN_CONTAINER_IsLoading: boolean;
    MAIN_CONTAINER_IsVisible: boolean;
    MAIN_CONTAINER_HasErrored: boolean;
    MAIN_CONTAINER_HasAccess: boolean;

    SAVE_REVISIONS_IsLoading: boolean;
    TRANSFER_DOCUMENTS_IsLoading: boolean;

    [index: string]: boolean;
}

export class ReqError
{
    statusText:string;
    error:string;
    constructor(statusText:string,error:string) { 
        this.statusText = statusText;
        this.error = error;
     } 
} 

export class ErrorResponse
{
    Message:string;
    ExceptionMessage:string;
    ExceptionType:string;
    StackTrace:string;
    InnerException: object;
    constructor(Message:string,ExceptionMessage:string, ExceptionType: string,StackTrace: string, InnerException: object ) { 
        this.Message = Message;
        this.ExceptionMessage = ExceptionMessage;
        this.ExceptionType = ExceptionType;
        this.StackTrace = StackTrace;
        this.InnerException = InnerException;
     } 
} 

export type UiItemsTypes = any|string[];

export interface UiItemState
{
    [uiItemNames.infoContainerItems]: string; 
    [uiItemNames.documentList]: PaDocument[];
    [uiItemNames.statusCodes]: RevStatusCode[];
    [uiItemNames.newMetaItemValues]: NewMetaItemValues[];
    [uiItemNames.revisionCodeValues]: RevisionCode[];
    [uiItemNames.archiveDefinition]: Archive|null;
    [uiItemNames.revToUpdate]: revMode; 
    [uiItemNames.errorMsgVisible]: boolean;
    [uiItemNames.levelToUpdate]: boolean;
    [uiItemNames.MetaItemPresentations]: MetaItemPresentations|null;
    [uiItemNames.MetaItemValidValues]: MetaItemPresentationValue[];
    [uiItemNames.errorMessage]: any;
    [uiItemNames.DPI]: number;

    [index: string]: any;
}

export interface Archive {
    DbRno: number;
    Name: string;
    RevisionDefinition: RevisionDefinition;
}

export interface RevisionDefinition {
    AllowEmptyRevisionCode: boolean;
    RevisionCodeMethod: number;
    Manual: boolean;
    MandatoryRevisionCodes: boolean;
    AcceptOnlyPredefinedCodes: boolean;
    AutomaticNumberingMethod: number;
    ManualOverrideRevisionCode: boolean;
    NumberOfRevisionCodeChars: number;
    DefaultRevisionCode: string;
    StatusDefinition: StatusDefinition;
    CreateRevisionOnNewDocumentProfile: boolean;
    ShowRevision: number;
}

export interface StatusDefinition {
    IsMandatory: boolean;
    Default: string;
  }

export interface RevisionCode {
    Revision: string,
    Description: string
}

export class apiPath{
    serviceName: string;
    methodName: string;
    constructor(serviceName:string,methodName:string) { 
        this.serviceName = serviceName;
        this.methodName = methodName;
     } 
}

export interface PaDocument{
    DocId: string,   
    DbRno: number,
    DocRno: number,
    RevisionToUpdate: PaRevision,
    CurrentRevision: PaRevision,
    Revisions: PaRevision[],
    TypeName: string,
    CurrentRevisionRno: number,
    MetaItems: MetaItem[],
}

export interface PaRevision {
    $id: string;
    $ref: string;
    RevisionLog: any;
    RevSeqno: number;
    StatusDate: string;
    DocRno: number;
    DbRno: number;
    Files: PaFile[];
    FileCount: number;
    Initiated: string;
    StatusBy: any//PaUser|null;
    StatusTypeRno: number;
    InitiatedBy: any//PaUser|null;
    Created: string;
    CreatedBy: any//PaUser|null;
    Status: string;
    RevRno: number;
    Rno: number;
    RevisionCode: string;
    Closed: boolean;
    MetaItems: MetaItem[];//|any;
    TypeName: string;
}

export interface MetaItemPresentations {
    DbRno: number;
    MetaItemPresentations: MetaItemPresentation[];
}

export interface MetaItemPresentation {
      ShowDropDownIcon: boolean;
      MaximumCharacters: number;
      Name: string;
      Visible: boolean;
      Mandatory: boolean;
      Enabled: boolean;
      LabelText: string;
}
export interface MetaItemPresentationValue {
        Value: string;
        MetaItems: MetaItem[];
}

export interface MetaItem {
    Name: string;
    Value?: any;
    HasMultipleValues: boolean;
    MultipleValues?: string[];
}

export interface NewMetaItemValues {
    DocumentID: string;
    NewRevision: boolean;
    NewRevCode: string;
    Status: string;
    Description: string;
    SaveResult: string;

    [index: string]: any;
}

export interface MetaItemValue {
    DocumentID: string;
    Attribute: string;
    Value: any;
}

export interface RevStatusCode {
    Value: string;
    Description: string
}

export interface PaFile {
    $id: string;
    UpdateWhenOpen: boolean
    IsIndexed: boolean,
    DateLastChanged: string,
    Size: number,
    OriginalFileName: string,
    LastUpdatedOnSite: number,
    DocPathId: number,
    DbRno: number,
    DocRno: number,
    RevRno: number,
    Version: number,
    Role: number,
    Visibility: number,
    ParentRno: number,
    PreviewRno: number,
    ThumbnailRno: number,
    RelatedFilesCount: number,
    CheckSum: string,
    Virtual: boolean,
    SiteRno: number,
    RevisionFileSeqno: number,
    CheckedOutFilePath: string,
    TemplateRno: number,
    GlobalFileId: string,
    GlobalParentFileId: string,
    Rno: number,
    FileRno: number,
    Name: string,
    Extension: string,
    Status: number,
    StatusUser: any,
    StatusDate: string,
    Comment: string,
    ProduceFileStatus: number,
    MetaItems: MetaItem[],
    TypeName: string
  }

export function mapActionToMethod(buttonAction:buttonActionTypes,param:string, param2?:string):apiPath {
    var mappings:apiPath;
    switch (buttonAction) {
        case buttonActionTypes.SAVE_FILE:                         
            mappings = new apiPath("proarc-bl/IFileManager/","SaveFileInfo")                 
            break;
        case buttonActionTypes.GET_CONFIG:                         
            mappings = new apiPath("proarc-sts/proarc/api/Settings/section","search")                 
            break;   
        case buttonActionTypes.GET_DOCUMENTS:                         
            mappings = new apiPath("proarc-bl/IDocumentManager","GetDocumentProfiles")                 
            break;
        case buttonActionTypes.GET_STATUS_CODES:                         
            mappings = new apiPath("proarc-bl/IMetaItemManager","GetValidDocumentMetaItemValues")                 
            break;
        case buttonActionTypes.GET_VALID_METAVALUES:                         
            mappings = new apiPath("proarc-bl/IMetaItemManager","GetValidDocumentMetaItemValues")                 
            break;
        case buttonActionTypes.SAVE_REVISION:                         
            mappings = new apiPath("proarc-bl/IRevisionManager","SaveRevision")                 
            break;
        case buttonActionTypes.GET_WEB_REQUEST:                         
            mappings = new apiPath("proarc-bl/IWebRequestManager","GetWebRequest")                 
            break;
        case buttonActionTypes.GET_REVISION_CODES:                         
            mappings = new apiPath("proarc-bl/IRevisionManager","GetRevisionCodes")                 
            break;
        case buttonActionTypes.GET_METAITEMPRESENTATION:                         
            mappings = new apiPath("proarc-bl/IFileManager","GetFilePresentation")                 
            break;
        case buttonActionTypes.GET_ARCHIVE:                         
            mappings = new apiPath("proarc-bl/IArchiveManager","GetArchive")                 
            break;
        case buttonActionTypes.VOID_FILE:                         
            mappings = new apiPath("proarc-bl/IFileManager","VoidFile")                 
            break;
        case buttonActionTypes.UNDO_VOID_FILE:                         
            mappings = new apiPath("proarc-bl/IFileManager","UnVoidFile")                 
            break;
        case buttonActionTypes.CHECK_ACCESS_TO_EXTENTION:                         
            mappings = new apiPath("MLayer","getUserAccessToExtension")                 
            break; 
        case buttonActionTypes.TRANSFER_FROM_FDV_TO_TOS:                         
            mappings = new apiPath("MLayer","copyDocumentToProteknisk")                 
            break;
        case buttonActionTypes.TRANSFER_FROM_PROTECH_TO_TOS:                         
            mappings = new apiPath("MLayer","copyDocumentToTosFromProteknisk")                 
            break;
        case buttonActionTypes.TRANSFER_HISTORISK_DOCUMENTS:                         
            mappings = new apiPath("MLayer","copyDocumentToFDV")                 
            break;   
        case buttonActionTypes.CONVERT_FILE:                         
            mappings = new apiPath("MLayer","ConvertPdfToJpgToPdf")               
            break;      
      default:
            mappings = new apiPath("","")   
          } 
    return mappings;
}